import { Box, Dialog, DialogContent, DialogActions, Button, Typography } from "@material-ui/core";
import { Close, Check } from "@mui/icons-material";

export default function AlertModal({ open, onClose, title, message, theme, type }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="alert-modal"
      PaperProps={{
        className: "alert-modal-paper",
      }}
    >
      <DialogContent className="alert-content">
        <Box className="alert-icon-wrapper" style={{ backgroundColor: type === "success" ? "#d1fae5" : "#fee2e2", color: type === "success" ? "#059669" : "#991b1b" }}>
          {type === "success" ? <Check className="alert-icon" /> : <Close className="alert-icon" />}
        </Box>
        <Typography className="alert-title">{title}</Typography>
        <Typography className="alert-message">{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          className="alert-ok-btn" 
          fullWidth
          style={{ backgroundColor: theme.primary }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
